module.exports = __webpack_public_path__ + "static/media/Cornell.f477534c.png";